// PROGRAM: Cart — Cart state, add/remove/change, drawer, savings calc
// Reads Liquid data from window.CARTOS_DATA (set by inline script)

(function() {
    'use strict';

    // Liquid data injected by inline script before this file loads
    var DATA = window.CARTOS_DATA || {};

    var Cart = {
        windowEl: null,
        contentEl: null,
        widgetCountEl: null,
        widgetEl: null,
        widgetStackEl: null,
        widgetSavingsEl: null,
        cartBottomCountEl: null,
        pageCartContentEl: null,

        // Debounce timer for batching rapid quantity clicks
        _changeTimer: null,
        _changePending: false,

        // [DISCOUNTS] - Data System
        savingsThresholds: [
            { amount: 99, reward: 'FREE SHIPPING', label: 'FREE SHIP', icon: '🚚' },
            { amount: 120, reward: '10% OFF', label: '10% OFF', icon: '🏷️' },
            { amount: 200, reward: '15% OFF', label: '15% OFF', icon: '🎁' },
            { amount: 350, reward: '20% OFF', label: '20% OFF', icon: '🔥' }
        ],

        // Wholesale pricing data
        wholesalePricing: [
            { quantity: '1 DOZEN', price: 60, label: '📦 1dz', theme: 'blue' },
            { quantity: '3 DOZEN', price: 50, label: '📦📦 3dz', theme: 'green' },
            { quantity: '5 DOZEN', price: 40, label: '📦📦📦 5dz', theme: 'gold', badge: 'BEST VALUE!' }
        ],

        // Member detection — set from CARTOS_DATA (Liquid-injected)
        isLoggedIn: DATA.isLoggedIn || false,
        customerName: DATA.customerName || '',

        // Use PROGRAMS engine for products (single source of truth)
        get recommendedProducts() { return window.PROGRAMS ? (PROGRAMS.products || []) : []; },

        cachedCart: null,

        // Check and sync login state
        recheckLogin: function() {
            // Re-read from DATA (set by Liquid inline script)
            var liquidCustomer = DATA.isLoggedIn || false;
            var liquidName = DATA.customerName || '';
            if (!liquidCustomer) {
                localStorage.removeItem('retard_global_member');
                this.isLoggedIn = false;
                this.customerName = '';
                return;
            }
            this.isLoggedIn = true;
            this.customerName = liquidName || 'Member';
            var storedMember = localStorage.getItem('retard_global_member');
            if (storedMember) {
                try { var parsed = JSON.parse(storedMember); if (parsed.name) this.customerName = parsed.name; } catch(e) {}
            }
        },

        init: function() {
            // Resolve DOM elements
            this.windowEl = document.getElementById('retro-cart-window');
            this.contentEl = document.getElementById('retro-cart-content');
            this.widgetCountEl = document.getElementById('widget-count');
            this.widgetEl = document.getElementById('retro-taskbar-widget');
            this.widgetStackEl = document.getElementById('retro-floating-buttons');
            this.widgetSavingsEl = document.getElementById('widget-savings');
            this.cartBottomCountEl = document.getElementById('cart-bottom-count');
            this.pageCartContentEl = document.getElementById('retro-page-cart-content');

            // Clear on logout detection
            if (document.referrer.includes('/account/logout') ||
                window.location.search.includes('logout=true') ||
                window.location.pathname.includes('/account/login')) {
                localStorage.removeItem('retard_global_member');
            }
            this.recheckLogin();
            // Intercept all add to cart forms
            var self = this;
            document.addEventListener('submit', function(e) {
                if (e.target.action && e.target.action.includes('/cart/add')) {
                    e.preventDefault();
                    self.addItem(new FormData(e.target));
                }
            });
            this.fetchCart();
        },

        toggle: function() {
            const isActive = this.windowEl.classList.contains('active');
            const backdrop = document.getElementById('cart-backdrop');
            if (isActive) {
                this.windowEl.classList.remove('active');
                document.body.classList.remove('cart-open');
                if(backdrop) backdrop.classList.remove('active');
            } else {
                this.windowEl.classList.add('active');
                document.body.classList.add('cart-open');
                if(backdrop) backdrop.classList.add('active');
                this.fetchCart();
            }
        },

        addItem: function(formData) {
            var self = this;
            // Cancel any pending debounced quantity change
            if (this._changeTimer) { clearTimeout(this._changeTimer); this._changeTimer = null; }
            this._changePending = true;
            fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            })
            .then(function(res) {
                if (!res.ok) throw new Error('Cart add failed: ' + res.status);
                return res.json();
            })
            .then(function(item) {
                self._changePending = false;
                self.fetchCart();
                if (window.location.pathname === '/cart') {
                    return;
                }
                var backdrop = document.getElementById('cart-backdrop');
                self.windowEl.classList.add('active');
                document.body.classList.add('cart-open');
                if(backdrop) backdrop.classList.add('active');
            })
            .catch(function(err) {
                console.error('CartOS addItem Error:', err);
                self._changePending = false;
                // Recovery: fetch actual state
                self.fetchCart();
            });
        },

        quickAdd: function(variantId) {
            var formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', 1);
            this.addItem(formData);
        },

        changeItem: function(key, qty) {
            var self = this;

            // INSTANT optimistic update — mutate cachedCart directly so
            // the next rapid click reads the already-updated quantity.
            // This makes every click feel instant regardless of network.
            if (this.cachedCart) {
                var itemIndex = -1;
                for (var i = 0; i < this.cachedCart.items.length; i++) {
                    if (this.cachedCart.items[i].key === key) { itemIndex = i; break; }
                }
                if (itemIndex !== -1) {
                    var oldQty = this.cachedCart.items[itemIndex].quantity;
                    var pricePer = this.cachedCart.items[itemIndex].line_price / oldQty;
                    if (qty === 0) {
                        this.cachedCart.total_price -= this.cachedCart.items[itemIndex].line_price;
                        this.cachedCart.item_count -= oldQty;
                        this.cachedCart.items.splice(itemIndex, 1);
                    } else {
                        var qtyDiff = qty - oldQty;
                        this.cachedCart.items[itemIndex].quantity = qty;
                        this.cachedCart.items[itemIndex].line_price = pricePer * qty;
                        this.cachedCart.total_price += pricePer * qtyDiff;
                        this.cachedCart.item_count += qtyDiff;
                    }
                    // Re-render immediately with updated cachedCart
                    this.render(this.cachedCart);
                    this.widgetCountEl.innerText = this.cachedCart.item_count;
                    if(this.cartBottomCountEl) this.cartBottomCountEl.innerText = this.cachedCart.item_count;
                    this.updateSavingsDisplays(this.cachedCart);
                    this.updateMemberProgressBar(this.cachedCart);
                }
            }

            // Debounce the server request — wait 150ms for clicks to settle,
            // then send ONE request with the final quantity.
            if (this._changeTimer) clearTimeout(this._changeTimer);
            this._changeTimer = setTimeout(function() {
                self._changeTimer = null;
                self._syncChange(key, qty);
            }, 150);
        },

        _syncChange: function(key, qty) {
            var self = this;
            // Find the actual current quantity from cachedCart (may have changed
            // since the debounce was scheduled if user kept clicking)
            var finalQty = qty;
            if (this.cachedCart) {
                for (var i = 0; i < this.cachedCart.items.length; i++) {
                    if (this.cachedCart.items[i].key === key) {
                        finalQty = this.cachedCart.items[i].quantity;
                        break;
                    }
                }
                // Item was removed (qty went to 0)
                var found = false;
                for (var i = 0; i < this.cachedCart.items.length; i++) {
                    if (this.cachedCart.items[i].key === key) { found = true; break; }
                }
                if (!found) finalQty = 0;
            }

            this._changePending = true;
            fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: key, quantity: finalQty })
            })
            .then(function(res) {
                if (!res.ok) throw new Error('Cart change failed: ' + res.status);
                return res.json();
            })
            .then(function(cart) {
                self._changePending = false;
                self.cachedCart = cart;
                self.render(cart);
                self.widgetCountEl.innerText = cart.item_count;
                if(self.cartBottomCountEl) self.cartBottomCountEl.innerText = cart.item_count;
                self.updateSavingsDisplays(cart);
                self.updateMemberProgressBar(cart);
                // Emit event for cross-program communication
                if (window.PROGRAMS && PROGRAMS.emit) PROGRAMS.emit('cart:updated', cart);
            })
            .catch(function(err) {
                console.error('CartOS Error:', err);
                self._changePending = false;
                // Recovery: re-fetch actual cart state from server
                self.fetchCart();
            });
        },

        fetchCart: function() {
            var self = this;
            fetch('/cart.js')
            .then(function(res) {
                if (!res.ok) throw new Error('Cart fetch failed: ' + res.status);
                return res.json();
            })
            .then(function(cart) {
                self.cachedCart = cart;
                self.render(cart);
                self.widgetCountEl.innerText = cart.item_count;
                if(self.cartBottomCountEl) self.cartBottomCountEl.innerText = cart.item_count;
                self.updateSavingsDisplays(cart);
                self.updateMemberProgressBar(cart);
                // Emit event for cross-program communication
                if (window.PROGRAMS && PROGRAMS.emit) PROGRAMS.emit('cart:updated', cart);
            })
            .catch(function(err) {
                console.error('CartOS fetchCart Error:', err);
            });
        },

        updateSavingsDisplays: function(cart) {
            var total = this.baseTotal(cart);
            var freeShipStr = this.formatBase(99);
            if (this.widgetSavingsEl) {
                if (total > 0 && !this.isLoggedIn) {
                    this.widgetSavingsEl.textContent = 'Save 15%';
                    this.widgetSavingsEl.classList.add('active');
                } else {
                    this.widgetSavingsEl.classList.remove('active');
                }
            }

            var guestPortalSavings = document.querySelectorAll('.guest-portal-savings');
            var guestPortalDiscount = document.querySelectorAll('.guest-portal-discount');

            var discountPercent = 0;
            if (total >= 350) discountPercent = 20;
            else if (total >= 200) discountPercent = 15;
            else if (total >= 120) discountPercent = 10;
            else if (total >= 99) discountPercent = 0;

            var savings = this.formatBase(total * (discountPercent / 100));

            guestPortalSavings.forEach(function(el) {
                if (total <= 0) {
                    return;
                } else if (discountPercent > 0) {
                    el.textContent = savings;
                    el.style.fontSize = '';
                } else {
                    el.textContent = 'FREE SHIPPING';
                    el.style.fontSize = '48px';
                }
            });
            guestPortalDiscount.forEach(function(el) {
                if (total <= 0) {
                    return;
                } else if (discountPercent > 0) {
                    el.textContent = discountPercent + '%';
                    el.parentElement.style.display = '';
                } else {
                    el.parentElement.style.display = 'none';
                }
            });

            if (typeof PROGRAMS !== 'undefined') {
                PROGRAMS.cartSavings = total * (discountPercent / 100);
                PROGRAMS.cartTotal = total;
            }

            var tierLabel = '';
            if (discountPercent === 20) tierLabel = '20% VIP';
            else if (discountPercent === 15) tierLabel = '15% off';
            else if (discountPercent === 10) tierLabel = '10% off';
            else if (total >= 99) tierLabel = 'FREE SHIPPING';

            var cartSavingsDisplays = document.querySelectorAll('.cart-savings-display');
            var cartSavingsHeaders = document.querySelectorAll('.cart-savings-header');
            var cartSavingsSubtexts = document.querySelectorAll('.cart-savings-subtext');

            cartSavingsDisplays.forEach(function(el) {
                if (total >= 120 && discountPercent > 0) {
                    el.textContent = savings;
                } else {
                    el.textContent = 'FREE SHIPPING';
                }
            });

            cartSavingsHeaders.forEach(function(el) {
                if (total >= 120 && discountPercent > 0) {
                    el.innerHTML = '<font face="Arial" size="1" color="#666">You could save</font><br>';
                } else {
                    el.innerHTML = '';
                }
            });

            cartSavingsSubtexts.forEach(function(el) {
                if (total >= 120 && discountPercent > 0) {
                    el.textContent = tierLabel + ' with Membership';
                } else {
                    el.textContent = 'AVAILABLE AT ' + freeShipStr + '+';
                }
            });
        },

        updateMemberProgressBar: function(cart) {
            var progressLabel = document.getElementById('msd-progress-label');
            var progressFill = document.getElementById('msd-progress-fill');
            var tiersContainer = document.getElementById('msd-tiers');
            if (!progressLabel || !progressFill || !tiersContainer) return;

            var total = this.baseTotal(cart);
            var thresholds = this.savingsThresholds;
            var maxThreshold = thresholds[thresholds.length - 1].amount;
            var progress = Math.min((total / maxThreshold) * 100, 100);
            progressFill.style.width = progress + '%';

            var currentTierIndex = -1;
            var nextTier = null;
            var needed = 0;
            for (var i = 0; i < thresholds.length; i++) {
                if (total >= thresholds[i].amount) {
                    currentTierIndex = i;
                } else if (!nextTier) {
                    nextTier = thresholds[i];
                    needed = thresholds[i].amount - total;
                }
            }

            if (total === 0) {
                progressLabel.textContent = 'Add items to unlock member savings!';
            } else if (nextTier) {
                progressLabel.textContent = 'Next: ' + nextTier.reward + ' (' + this.formatBase(needed) + ' to go)';
            } else {
                progressLabel.textContent = '🎉 MAXIMUM SAVINGS UNLOCKED!';
            }

            var tiersHtml = '';
            for (var i = 0; i < thresholds.length; i++) {
                var tier = thresholds[i];
                var tierClass = '';
                if (total >= tier.amount) {
                    tierClass = 'unlocked';
                } else if (i === currentTierIndex + 1) {
                    tierClass = 'current';
                }
                tiersHtml += '<div class="msd-tier ' + tierClass + '">' +
                    '<span class="msd-tier-icon">' + tier.icon + '</span>' +
                    '<span class="msd-tier-label">' + tier.label + '</span>' +
                    '<span class="msd-tier-amount">' + this.formatBase(tier.amount) + '</span>' +
                '</div>';
            }
            tiersContainer.innerHTML = tiersHtml;
        },

        // ── Currency (Shopify Markets presentment) ───────────────────────
        // The drawer is fully JS-rendered, so it must format money in the
        // shopper's PRESENTMENT currency — not a hardcoded "$". cart.js amounts
        // (total_price, line_price…) are already in presentment subunits, e.g.
        // a 245 zł cart returns 24500 with Shopify.currency.active === 'PLN'.
        // For a USD shopper rate===1 and these reduce to the original output,
        // so the US experience is byte-for-byte unchanged.
        currencyCode: function() {
            return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
        },
        // Presentment units per 1 USD of base price (PLN→~3.77, USD→1).
        currencyRate: function() {
            var r = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
            return (r && r > 0) ? r : 1;
        },
        // Format presentment-currency SUBUNITS (cart.js cents) → "245,00 zł" / "¥10,700" / "$245.00".
        formatMoney: function(cents) {
            var amount = (Number(cents) || 0) / 100;
            try {
                return new Intl.NumberFormat(undefined, { style: 'currency', currency: this.currencyCode() }).format(amount);
            } catch (e) {
                return '$' + amount.toFixed(2);
            }
        },
        // Format a USD-denominated marketing amount (a $99 threshold, "$5 more")
        // in the shopper's currency. Decimal places follow the CURRENCY (JPY/KRW→0,
        // PLN/USD→2, KWD→3) — NOT the converted number's integer-ness — so the
        // $99 free-ship bar reads "¥16,212" not "¥16,211.95"; whole amounts stay
        // clean ("$99", not "$99.00").
        formatBase: function(usd) {
            var amount = (Number(usd) || 0) * this.currencyRate();
            var code = this.currencyCode();
            try {
                var maxFrac = new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).resolvedOptions().maximumFractionDigits;
                var factor = Math.pow(10, maxFrac);
                var rounded = Math.round(amount * factor) / factor;
                var fd = (maxFrac > 0 && Math.round(rounded) !== rounded) ? maxFrac : 0;
                return new Intl.NumberFormat(undefined, { style: 'currency', currency: code, minimumFractionDigits: fd, maximumFractionDigits: fd }).format(rounded);
            } catch (e) {
                return '$' + (Number.isInteger(amount) ? amount : amount.toFixed(2));
            }
        },
        // Cart total expressed in USD base, for comparing against the USD reward
        // thresholds (99/120/200/350). USD shopper → unchanged (rate 1).
        baseTotal: function(cart) {
            return (cart.total_price / 100) / this.currencyRate();
        },

        generateHTML: function(cart) {
            var self = this;
            if (cart.item_count === 0) {
                var emptyRecommendedHtml = '';
                var products = this.recommendedProducts;
                if (products && products.length > 0) {
                    var displayProducts = products.slice(0, 4);
                    displayProducts.forEach(function(product) {
                        emptyRecommendedHtml += '<div style="width:100%;margin-bottom:8px">' +
                            '<div style="background:#3a0a10;border:2px outset #8B0000">' +
                            '<div style="background:#AA00AA;padding:4px 6px">' +
                            '<font face="Arial" size="1" color=#0FC><b>📁 ' + (product.title.length > 30 ? product.title.substring(0, 30) + '...' : product.title) + '</b></font>' +
                            '</div>' +
                            '<div style="padding:6px;background:#1a0508;border:2px inset #1a0508">' +
                            '<a href="' + product.url + '" style="text-decoration:none;display:block">' +
                            '<img src="' + product.image.replace('width=150', 'width=400') + '" style="width:100%;height:auto;border:3px solid #AA00AA;display:block" alt="' + product.title + '">' +
                            '</a>' +
                            '<div style="margin-top:6px;background:#3a0a10;border:2px inset #1a0508;padding:6px">' +
                            '<font face="Courier New" size="1" color=#0F8><b>' + product.title + '</b></font><br>' +
                            '<font face="Courier New" size="3" color=#0FC><b>' + product.priceFormatted + '</b></font>' +
                            '</div>' +
                            '<table border="0" cellpadding="0" cellspacing="0" style="margin-top:6px;width:100%;cursor:pointer" onclick="CartOS.quickAdd(' + product.variantId + ')">' +
                            '<tr><td style="background:#600060;border:2px outset #AA00AA;padding:8px;text-align:center">' +
                            '<font face="Arial" size="2" color=#0FC><b>+ Add to Cart</b></font>' +
                            '</td></tr>' +
                            '</table>' +
                            '</div>' +
                            '</div>' +
                            '</div>';
                    });
                }

                setTimeout(function() {
                    var moneyEl = document.getElementById('empty-cart-cycling-money');
                    if (moneyEl) {
                        var count = 1;
                        setInterval(function() {
                            count = count >= 6 ? 1 : count + 1;
                            moneyEl.textContent = '$'.repeat(count);
                        }, 400);
                    }
                }, 100);

                return '<div style="background:#C0C0C0;border:2px outset #FFF">' +
                    '<div style="background:#1084d0;padding:8px 12px;border-bottom:2px solid #000080">' +
                    '<font face="Arial" size="2" color="#FFF"><b>📦 CARGO MANIFEST</b></font>' +
                    '</div>' +
                    '<div style="padding:8px;background:#C0C0C0">' +
                    '<div class="marching-ants-cart">' +
                    '<div style="background:#3a0a10;border:2px outset #8B0000">' +
                    '<div style="background:#AA00AA;padding:6px 10px">' +
                    '<font face="Arial" size="1" color=#0FC><b>🛒 YOUR CART</b></font>' +
                    '</div>' +
                    '<div style="padding:6px;background:#1a0508;border:2px inset #1a0508;margin:6px">' +
                    '<div class="add-more-container" style="display:flex;flex-direction:column">' +
                    '<div class="add-more-btn add-more-marching-ants" onclick="CartOS.toggleAddMore(this)">' +
                    '<font face="Arial" size="3" color=#0FC><b class="add-more-text">+ Add More Items</b></font>' +
                    '</div>' +
                    '<div class="add-more-panel" style="display:none;margin-top:8px;background:#C0C0C0;border:2px outset #FFF">' +
                    '<div style="background:#1084d0;padding:4px 8px;display:flex;justify-content:space-between;align-items:center">' +
                    '<font face="Arial" size="1" color="#FFF"><b>📦 QUICK ADD CART</b></font>' +
                    '<span onclick="CartOS.toggleAddMore(this)" style="color:#FFF;cursor:pointer;font-size:12px">✕</span>' +
                    '</div>' +
                    '<div style="padding:8px;background:#C0C0C0">' +
                    self.generateQuickAddItems() +
                    '</div>' +
                    '<div style="padding:6px;background:#A0A0A0;border-top:2px groove #FFF;text-align:center">' +
                    '<a href="/collections/all" style="text-decoration:none"><font face="Arial" size="1" color="#00F"><b>Browse All Products →</b></font></a>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div style="background:#3a0a10;border:2px outset #8B0000;margin-top:8px">' +
                    '<div style="background:#AA00AA;padding:6px 10px">' +
                    '<font face="Arial" size="1" color=#0FC><b>📸 PRODUCT SHOTS</b></font>' +
                    '</div>' +
                    '<div style="padding:6px;background:#1a0508;border:2px inset #1a0508;margin:6px">' + emptyRecommendedHtml + '</div>' +
                    '</div>' +
                    '<div style="margin-top:3px">' + self.generateMembershipProgressBar(0) + '</div>' +
                    '<div style="margin-top:3px">' + self.generateMembershipCTA(0) + '</div>' +
                    '</div>' +
                    '</div>';
            }

            // Cart has items.
            // total    = presentment amount (PLN/JPY/USD) — drives money DISPLAYS (formatMoney).
            // tierTotal = same spend expressed in USD base — drives reward THRESHOLD compares
            //             (99/120/200/350 are USD). For a USD shopper the two are equal.
            var total = cart.total_price / 100;
            var tierTotal = this.baseTotal(cart);
            var thresholds = this.savingsThresholds;
            var maxThreshold = thresholds[thresholds.length - 1].amount;
            var nextTier = null;
            var needed = 0;
            var currentTierIndex = -1;
            for (var i = 0; i < thresholds.length; i++) {
                if (tierTotal >= thresholds[i].amount) {
                    currentTierIndex = i;
                } else if (!nextTier) {
                    nextTier = thresholds[i];
                    needed = thresholds[i].amount - tierTotal;
                }
            }
            var progress = Math.min((tierTotal / maxThreshold) * 100, 100);
            var formattedTotal = this.formatMoney(cart.total_price);

            // Members-only: only logged-in members see the discounted total (it's
            // enforced for them server-side by the member-tier Function). Guests see
            // FULL price + the "join to unlock" prompt — never a discount they won't get.
            var discountPercent = 0;
            var discountLabel = '';
            if (self.isLoggedIn) {
                if (currentTierIndex === 1) { discountPercent = 10; discountLabel = '10% OFF'; }
                else if (currentTierIndex === 2) { discountPercent = 15; discountLabel = '15% OFF'; }
                else if (currentTierIndex === 3) { discountPercent = 20; discountLabel = '20% OFF'; }
            }

            var discountedTotal = total * (1 - discountPercent / 100);
            var savings = total - discountedTotal;
            var formattedDiscountedTotal = this.formatMoney(Math.round(discountedTotal * 100));
            var formattedSavings = this.formatMoney(Math.round(savings * 100));

            // Build cart items HTML
            var itemsHtml = '';
            cart.items.forEach(function(item) {
                var formattedPrice = self.formatMoney(item.line_price);
                var itemPrice = item.line_price / 100;
                var discountedItemPrice = itemPrice * (1 - discountPercent / 100);
                var formattedDiscountedPrice = self.formatMoney(Math.round(discountedItemPrice * 100));

                var priceDisplay = discountPercent > 0
                    ? '<span style="text-decoration:line-through;color:#FF6666;font-size:10px">' + formattedPrice + '</span> <span style="font:bold 12px \'Courier New\', monospace;color:#0F0">' + formattedDiscountedPrice + '</span>'
                    : '<span style="font:bold 12px \'Courier New\', monospace;color:#00FFCC">' + formattedPrice + '</span>';

                itemsHtml += '<div style="position:relative;display:flex;gap:8px;margin-bottom:10px;background:#3a0a10;border:2px outset #8B0000;padding:6px;padding-right:24px">' +
                    '<span onclick="CartOS.changeItem(\'' + item.key + '\', 0)" style="position:absolute;top:4px;right:4px;color:#446666;cursor:pointer;font-size:10px;padding:1px 4px;opacity:0.5" onmouseover="this.style.opacity=\'1\';this.style.color=\'#FF6666\'" onmouseout="this.style.opacity=\'0.5\';this.style.color=\'#446666\'">✕</span>' +
                    '<div style="width:80px;flex-shrink:0">' +
                    '<a href="' + item.url + '" style="text-decoration:none;display:block">' +
                    '<img src="' + item.image + '" style="width:80px;height:80px;object-fit:cover;border:2px solid #AA00AA;display:block" alt="' + item.product_title + '">' +
                    '</a>' +
                    '</div>' +
                    '<div style="flex:1;display:flex;flex-direction:column;justify-content:space-between">' +
                    '<div>' +
                    '<font face="Courier New" size="1" color=#0F8><b>' + (item.product_title.length > 25 ? item.product_title.substring(0, 25) + '...' : item.product_title) + '</b></font>' +
                    (item.variant_title ? '<br><font face="Courier New" size="1" color="#00CCAA">' + item.variant_title + '</font>' : '') +
                    '<div style="margin-top:4px">' + priceDisplay + '</div>' +
                    '</div>' +
                    '<div style="display:flex;justify-content:flex-end;margin-top:8px">' +
                    '<div class="os-qty-box" style="display:inline-flex;flex-direction:row;flex-wrap:nowrap;align-items:center;background:#003333;border:2px solid #008080;gap:0">' +
                    '<button type="button" class="os-btn-small" onclick="CartOS.changeItem(\'' + item.key + '\', ' + (item.quantity - 1) + ')" style="display:inline-flex;align-items:center;justify-content:center;cursor:pointer;color:#00FFCC;font-weight:bold;font-family:Arial,sans-serif;border:none;border-right:1px solid #008080;background:#003333;margin:0;padding:0">−</button>' +
                    '<span class="os-qty-display" style="display:inline-flex;align-items:center;justify-content:center;color:#00FFCC;font-weight:bold;font-family:Courier New,monospace;background:#001a1a">' + item.quantity + '</span>' +
                    '<button type="button" class="os-btn-small" onclick="CartOS.changeItem(\'' + item.key + '\', ' + (item.quantity + 1) + ')" style="display:inline-flex;align-items:center;justify-content:center;cursor:pointer;color:#00FFCC;font-weight:bold;font-family:Arial,sans-serif;border:none;border-left:1px solid #008080;background:#003333;margin:0;padding:0">+</button>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>';
            });

            var suggestProduct = null;
            for (var i = 0; i < this.recommendedProducts.length; i++) {
                var p = this.recommendedProducts[i];
                var inCart = false;
                for (var j = 0; j < cart.items.length; j++) {
                    if (cart.items[j].product_id === p.id) { inCart = true; break; }
                }
                if (!inCart) { suggestProduct = p; break; }
            }
            if (!suggestProduct && this.recommendedProducts.length > 0) suggestProduct = this.recommendedProducts[0];

            // Reward/“you could save” math is denominated in USD base, then
            // formatted into the shopper's currency via formatBase().
            var rate = this.currencyRate();
            var suggestPriceBase = suggestProduct ? (suggestProduct.price / 100) / rate : 50;
            var newTotal = tierTotal + suggestPriceBase;
            var newDiscountPercent = 0;
            if (newTotal >= 350) newDiscountPercent = 20;
            else if (newTotal >= 200) newDiscountPercent = 15;
            else if (newTotal >= 120) newDiscountPercent = 10;
            var suggestSavings = this.formatBase(suggestPriceBase * (newDiscountPercent / 100));
            var currentSavings = this.formatBase(tierTotal * (discountPercent / 100));
            var proposedProductSavingsNum = suggestProduct ? (suggestPriceBase * 0.15) : 9.75;
            var minSavings = proposedProductSavingsNum > 21 ? proposedProductSavingsNum : 21.00;
            var calculatedNewSavings = newTotal * (newDiscountPercent / 100);
            var potentialNewSavings = this.formatBase(calculatedNewSavings >= 1 ? calculatedNewSavings : minSavings);
            var showFreeShippingProgress = tierTotal < 99 && tierTotal > 0;
            var freeShippingNeeded = showFreeShippingProgress ? this.formatBase(99 - tierTotal) : this.formatBase(0);

            // Build tier progress bar
            var tierBarHtml = (function() {
                var barProgress = Math.min((tierTotal / 350) * 100, 100);
                var barHtml = '<div style="margin-top:8px">';
                barHtml += '<div style="background:#808080;border:2px inset #404040;height:16px;position:relative">';
                barHtml += '<div style="background:#00AAAA;height:100%;width:' + barProgress + '%;transition:width 0.3s ease"></div>';
                barHtml += '</div>';
                barHtml += '<div style="display:flex;justify-content:space-between;margin-top:4px;gap:2px">';

                var shipActive = tierTotal >= 99;
                barHtml += '<div class="' + (shipActive ? 'tier-glow-box' : '') + '" style="flex:1;text-align:center;padding:3px 1px;background:' + (shipActive ? '#006666' : '#1a4a4a') + ';border:2px ' + (shipActive ? 'inset #004444' : 'outset #2a6a6a') + '"><font face="Arial" size="1" color="' + (shipActive ? '#00FFCC' : '#5a8a8a') + '"><b>🚚FREE SHIP</b></font></div>';

                var tier10Active = tierTotal >= 120;
                barHtml += '<div class="' + (tier10Active ? 'tier-glow-box' : '') + '" style="flex:1;text-align:center;padding:3px 1px;background:' + (tier10Active ? '#006666' : '#1a4a4a') + ';border:2px ' + (tier10Active ? 'inset #004444' : 'outset #2a6a6a') + '"><font face="Arial" size="1" color="' + (tier10Active ? '#FFCC00' : '#5a8a8a') + '"><b>10% OFF</b></font></div>';

                var tier15Active = tierTotal >= 200;
                barHtml += '<div class="' + (tier15Active ? 'tier-glow-box' : '') + '" style="flex:1;text-align:center;padding:3px 1px;background:' + (tier15Active ? '#006666' : '#1a4a4a') + ';border:2px ' + (tier15Active ? 'inset #004444' : 'outset #2a6a6a') + '"><font face="Arial" size="1" color="' + (tier15Active ? '#00FF00' : '#5a8a8a') + '"><b>15% OFF</b></font></div>';

                var tier20Active = tierTotal >= 350;
                barHtml += '<div class="' + (tier20Active ? 'tier-glow-box' : '') + '" style="flex:1;text-align:center;padding:3px 1px;background:' + (tier20Active ? '#006666' : '#1a4a4a') + ';border:2px ' + (tier20Active ? 'inset #004444' : 'outset #2a6a6a') + '"><font face="Arial" size="1" color="' + (tier20Active ? '#FF00FF' : '#5a8a8a') + '"><b>👑20% OFF</b></font></div>';

                barHtml += '</div>';

                if (tierTotal > 0 && tierTotal < 350) {
                    var nextTierVal = tierTotal < 99 ? 99 : tierTotal < 120 ? 120 : tierTotal < 200 ? 200 : 350;
                    var untilNext = self.formatBase(nextTierVal - tierTotal);
                    var nextLabel = nextTierVal === 99 ? 'FREE SHIPPING' : nextTierVal === 120 ? '10% OFF' : nextTierVal === 200 ? '15% OFF' : '20% VIP';
                    barHtml += '<div class="next-tier-cta" style="text-align:center;margin-top:6px;padding:4px;background:#001a00;border:2px solid #00FF00">';
                    barHtml += '<span class="next-tier-text" style="font-family:Arial;font-size:12px;font-weight:bold">';
                    barHtml += '<span class="urgency-symbol" style="display:inline-block">→</span> ';
                    barHtml += 'NEXT TIER: Add ' + untilNext + ' for ' + nextLabel + '!';
                    barHtml += ' <span class="urgency-symbol" style="display:inline-block">→</span>';
                    barHtml += '</span></div>';
                } else if (tierTotal >= 350) {
                    barHtml += '<div style="text-align:center;margin-top:6px;padding:4px;background:#1a1a00;border:1px solid #FFD700">';
                    barHtml += '<font face="Arial" size="2" color="#FFD700"><b>🏆 MAX TIER ACHIEVED! 20% VIP! 🏆</b></font></div>';
                }

                barHtml += '</div>';
                return barHtml;
            })();

            // Free shipping / discount boxes
            var discountBoxesHtml = '';
            if (tierTotal >= 99) {
                discountBoxesHtml += '<div class="cart-discount-box" style="background:#C0C0C0;border:2px outset #FFF;margin-bottom:8px">' +
                    '<div style="background:#008800;padding:4px 8px;text-align:center">' +
                    '<font face="Arial" size="1" color="#FFF"><b>🚚 FREE SHIPPING UNLOCKED!</b></font>' +
                    '</div></div>';
            }
            if (discountPercent > 0) {
                discountBoxesHtml += '<div class="cart-discount-box" style="background:#C0C0C0;border:2px outset #FFF;margin-bottom:8px">' +
                    '<div style="background:#00AA00;padding:4px 8px;text-align:center">' +
                    '<font face="Arial" size="1" color="#FFF"><b>💰 ' + discountLabel + ' APPLIED!</b></font>' +
                    '</div>' +
                    '<table border="0" cellpadding="4" cellspacing="0" width="100%" style="background:#FFFFCC">' +
                    '<tr><td align="left"><font face="Arial" size="1" color="#666">Subtotal:</font></td>' +
                    '<td align="right"><font face="Arial" size="2" color="#666" style="text-decoration:line-through">' + formattedTotal + '</font></td></tr>' +
                    '<tr><td align="left"><font face="Arial" size="1" color="#008000"><b>You Save:</b></font></td>' +
                    '<td align="right"><font face="Arial" size="2" color="#008000"><b>-' + formattedSavings + '</b></font></td></tr>' +
                    '</table></div>';
            }

            // Total display
            var totalDisplay = discountPercent > 0
                ? '<div style="text-align:right"><font face="Courier New" size="2" color="#FF6666" style="text-decoration:line-through">' + formattedTotal + '</font><br><font face="Courier New" size="4" color="#0F0"><b>' + formattedDiscountedTotal + '</b></font></div>'
                : '<font face="Courier New" size="4" color=#0F8><b>' + formattedTotal + '</b></font>';

            // Guest CTA
            var guestCta = !this.isLoggedIn
                ? '<div style="background:#CC0000;border:4px solid #FFFF00;padding:12px;margin:6px;text-align:center">' +
                  '<font face="Arial" size="2" color="#FFFF00"><b>JOIN FREE — UNLOCK MEMBER PRICING</b></font><br>' +
                  '<font face="Arial" size="1" color="#FFF">You\'re seeing FULL prices. Members save up to 20%!</font><br>' +
                  '<a href="/account/register" style="display:inline-block;margin-top:9px;background:#C0C0C0;border:3px outset #FFF;padding:15px 24px;min-height:48px;box-sizing:border-box;text-decoration:none;color:#000080;font-weight:bold;font-size:15px">🎁 JOIN FREE - UNLOCK SAVINGS</a></div>'
                : '';

            // Suggest product
            var suggestHtml = suggestProduct
                ? '<div style="background:#FFF;border:2px solid #CC1133;margin:6px">' +
                  '<div style="background:#CC1133;padding:4px 8px">' +
                  '<font face="Arial" size="1" color="#FFE088"><b>💡 IF YOU ADDED THIS...</b></font></div>' +
                  '<div style="padding:8px;display:flex;gap:8px;align-items:center">' +
                  '<div style="width:60px;flex-shrink:0"><a href="' + suggestProduct.url + '">' +
                  '<img src="' + suggestProduct.image.replace('width=150', 'width=120') + '" style="width:60px;height:60px;object-fit:cover;border:2px solid #AA00AA" alt="' + suggestProduct.title + '"></a></div>' +
                  '<div style="flex:1"><font face="Arial" size="1" color="#000080"><b>' + (suggestProduct.title.length > 25 ? suggestProduct.title.substring(0, 25) + '...' : suggestProduct.title) + '</b></font><br>' +
                  '<font face="Arial" size="2" color="#F00"><b>' + suggestProduct.priceFormatted + '</b></font></div>' +
                  '<div style="flex-shrink:0"><div class="purple-add-btn" onclick="CartOS.quickAdd(' + suggestProduct.variantId + ')" style="cursor:pointer;text-align:center">' +
                  '<font face="Arial" size="2" color="#FFF"><b>+ ADD</b></font></div></div></div></div>'
                : '';

            // You would save window
            var saveWindowHtml = '';
            if (showFreeShippingProgress) {
                saveWindowHtml = '<div style="background:#E8FFE8;border:3px solid #006600">' +
                    '<div style="background:#008800;padding:4px 8px"><font face="Arial" size="1" color="#FFF"><b>🚚 FREE SHIPPING</b></font></div>' +
                    '<div style="padding:8px;text-align:center"><font face="Arial" size="2" color="#006600">Add <b>' + freeShippingNeeded + '</b> more!</font><br>' +
                    '<font face="Times New Roman" size="4" color="#006600"><b>Orders ' + this.formatBase(99) + '+ ship FREE</b></font></div></div>';
            } else {
                saveWindowHtml = '<div style="background:#FFFFCC;border:3px solid ' + (this.isLoggedIn ? '#006600' : '#CCC') + '">' +
                    '<div style="background:' + (this.isLoggedIn ? 'linear-gradient(90deg, #006600, #008800)' : 'linear-gradient(90deg, #808080, #A0A0A0)') + ';padding:4px 8px">' +
                    '<font face="Arial" size="1" color="#FFF"><b>' + (this.isLoggedIn ? '💰 YOU ARE SAVING' : '💡 You could be saving...') + '</b></font></div>' +
                    '<div style="padding:8px;text-align:center"><font face="Times New Roman" size="5" color="' + (this.isLoggedIn ? '#006600' : '#F00') + '"><b>' + potentialNewSavings + '</b></font><br>' +
                    '<font face="Arial" size="1" color="' + (this.isLoggedIn ? '#006600' : '#666') + '"><i>' + (this.isLoggedIn ? 'with your member rewards!' : 'with FREE membership benefits!') + '</i></font></div></div>';
            }

            // Build complete cart HTML
            var html = '<div style="background:#C0C0C0;border:2px outset #FFF">' +
                '<div style="background:#1084d0;padding:8px 12px;border-bottom:2px solid #000080">' +
                '<font face="Arial" size="2" color="#FFF"><b>📦 CARGO MANIFEST (' + cart.item_count + ' items)</b></font></div>' +
                '<div style="padding:8px;background:#C0C0C0">' +
                '<div class="marching-ants-cart">' +
                '<div style="background:#3a0a10;border:2px outset #8B0000">' +
                '<div style="background:#AA00AA;padding:6px 10px">' +
                '<font face="Arial" size="1" color=#0FC><b>🛒 YOUR CART</b></font></div>' +
                '<div style="padding:6px;background:#1a0508;border:2px inset #1a0508;margin:6px;min-height:200px">' +
                itemsHtml +
                '<div class="add-more-container" style="margin:10px 0;flex:1;display:flex;flex-direction:column">' +
                '<div class="add-more-btn add-more-marching-ants" onclick="CartOS.toggleAddMore(this)" style="flex:1;display:flex;align-items:center;justify-content:center;min-height:100px">' +
                '<font face="Arial" size="3" color=#0FC><b class="add-more-text">+ Add More Items</b></font></div>' +
                '<div class="add-more-panel" style="display:none;margin-top:8px;background:#C0C0C0;border:2px outset #FFF">' +
                '<div style="background:#1084d0;padding:4px 8px;display:flex;justify-content:space-between;align-items:center">' +
                '<font face="Arial" size="1" color="#FFF"><b>📦 Quick Add Items</b></font>' +
                '<span onclick="CartOS.toggleAddMore(this)" style="color:#FFF;cursor:pointer;font-size:12px">✕</span></div>' +
                '<div style="padding:8px;background:#C0C0C0;padding:8px">' + self.generateQuickAddItems() + '</div>' +
                '<div style="padding:6px;background:#A0A0A0;border-top:2px groove #FFF;text-align:center">' +
                '<a href="/collections/all" style="text-decoration:none"><font face="Arial" size="1" color="#00F"><b>Browse All Products →</b></font></a></div>' +
                '</div></div></div>' +
                '<div style="background:#1a0508;border:2px inset #3a0a10;padding:8px;margin:0 6px 6px 6px">' +
                discountBoxesHtml +
                '<div style="display:flex;justify-content:space-between;align-items:center">' +
                '<font face="Arial" size="2" color=#0FC><b>TOTAL:</b></font>' + totalDisplay + '</div>' +
                tierBarHtml +
                '</div>' +
                '<div style="padding:8px 6px"><a href="/checkout" style="text-decoration:none;display:block">' +
                '<div class="jade-checkout-btn" style="padding:18px 24px;text-align:center;min-height:60px;display:flex;align-items:center;justify-content:center;gap:8px">' +
                '<font face="Arial" size="4" color="#FFFFFF"><b>🛒 CHECKOUT NOW</b></font></div></a></div>' +
                guestCta +
                '<div style="display:flex;justify-content:center;gap:12px;padding:6px;background:#E8E8E8;border:2px inset #C0C0C0;margin:6px">' +
                '<font face="Arial" size="1" color="#008000"><b>🔒 Secure</b></font>' +
                '<font face="Arial" size="1" color="#000080"><b>🚚 FREE ' + this.formatBase(99) + '+</b></font>' +
                '<font face="Arial" size="1" color="#800080"><b>💯 30-Day Guarantee</b></font></div>' +
                '<div style="display:flex;gap:6px;padding:0 6px 6px 6px">' +
                '<a href="/cart" style="flex:1;display:block;text-decoration:none">' +
                '<div style="background:#006666;border:3px outset #00AAAA;padding:14px;text-align:center;cursor:pointer;min-height:48px;display:flex;align-items:center;justify-content:center">' +
                '<font face="Arial" size="2" color="#FFF"><b>🛒 VIEW CART</b></font></div></a></div>' +
                suggestHtml +
                '<div style="text-align:center;margin:6px">' + saveWindowHtml + '</div>' +
                '</div></div>' +
                '<div style="margin-top:3px">' + self.generateMembershipProgressBar(tierTotal) + '</div>' +
                '<div style="margin-top:3px">' + self.generateRecommendedProducts(cart) + '</div>' +
                '<div style="margin-top:3px">' + self.generateMembershipCTA(tierTotal) + '</div>' +
                '</div></div>';

            return html;
        },

        toggleAddMore: function(btn) {
            var container = btn.closest('.add-more-container');
            if (!container) return;
            var panel = container.querySelector('.add-more-panel');
            var text = container.querySelector('.add-more-text');
            if (panel && text) {
                if (panel.classList.contains('open')) {
                    panel.classList.remove('open');
                    text.innerHTML = '+ Add More Items';
                } else {
                    panel.classList.add('open');
                    text.innerHTML = '− Close';
                }
            }
        },

        toggleQuickAddRec: function(btn) {
            var container = btn.closest('.quick-add-container');
            if (!container) return;
            var panel = container.querySelector('.quick-add-panel');
            var text = container.querySelector('.quick-add-text');
            if (panel && text) {
                if (panel.classList.contains('open')) {
                    panel.classList.remove('open');
                    text.innerHTML = '📦 QUICK ADD CART';
                } else {
                    panel.classList.add('open');
                    text.innerHTML = '− CLOSE QUICK ADD';
                }
            }
        },

        generateQuickAddItems: function() {
            var products = this.recommendedProducts;
            if (!products || products.length === 0) return '<font face="Arial" size="1" color="#666"><i>No products available</i></font>';

            var html = '<div style="display:flex;flex-wrap:wrap;gap:8px">';
            products.slice(0, 4).forEach(function(product) {
                html += '<div style="width:calc(50% - 4px);box-sizing:border-box">' +
                    '<div style="background:#C0C0C0;border:2px outset #FFF;height:100%">' +
                    '<div style="background:#1084d0;padding:3px 6px">' +
                    '<font face="Arial" size="1" color="#FFF"><b>📁 ' + (product.title.length > 12 ? product.title.substring(0, 12) + '...' : product.title) + '</b></font></div>' +
                    '<div style="padding:6px">' +
                    '<a href="' + product.url + '" style="text-decoration:none;display:block">' +
                    '<img src="' + product.image.replace('width=150', 'width=300') + '" style="width:100%;height:auto;aspect-ratio:1;object-fit:cover;border:2px inset #808080;display:block" alt="' + product.title + '"></a>' +
                    '<div style="margin-top:6px;background:#FFF;border:2px inset #808080;padding:4px;text-align:center">' +
                    '<font face="Arial" size="1" color="#008000"><b>' + product.priceFormatted + '</b></font></div>' +
                    '<div class="purple-add-btn" style="margin-top:6px;width:100%;cursor:pointer;text-align:center" onclick="CartOS.quickAdd(' + product.variantId + ')">' +
                    '<font face="Arial" size="2" color="#FFF"><b>+ ADD</b></font></div>' +
                    '</div></div></div>';
            });
            html += '</div>';
            return html;
        },

        generateRecommendedProducts: function(cart) {
            var products = this.recommendedProducts;
            if (!products || products.length === 0) return '';

            var cartProductIds = cart.items.map(function(item) { return item.product_id; });
            var filteredProducts = products.filter(function(p) { return cartProductIds.indexOf(p.id) === -1; }).slice(0, 4);
            if (filteredProducts.length === 0) return '';

            var smallCardsHtml = '';
            filteredProducts.forEach(function(product) {
                smallCardsHtml += '<div style="width:calc(50% - 4px);box-sizing:border-box">' +
                    '<div style="background:#C0C0C0;border:2px outset #FFF;height:100%">' +
                    '<div style="background:#1084d0;padding:3px 6px">' +
                    '<font face="Arial" size="1" color="#FFF"><b>📁 ' + (product.title.length > 12 ? product.title.substring(0, 12) + '...' : product.title) + '</b></font></div>' +
                    '<div style="padding:6px">' +
                    '<a href="' + product.url + '" style="text-decoration:none;display:block">' +
                    '<img src="' + product.image.replace('width=150', 'width=300') + '" style="width:100%;height:auto;aspect-ratio:1;object-fit:cover;border:2px inset #808080;display:block" alt="' + product.title + '"></a>' +
                    '<div style="margin-top:6px;background:#FFF;border:2px inset #808080;padding:4px;text-align:center">' +
                    '<font face="Arial" size="1" color="#008000"><b>' + product.priceFormatted + '</b></font></div>' +
                    '<div class="purple-add-btn" style="margin-top:6px;width:100%;cursor:pointer;text-align:center" onclick="CartOS.quickAdd(' + product.variantId + ')">' +
                    '<font face="Arial" size="2" color="#FFF"><b>+ ADD</b></font></div>' +
                    '</div></div></div>';
            });

            return '<div style="margin-top:8px;background:#FFF;border:3px solid #CCC">' +
                '<div style="background:#000080;padding:6px;text-align:center">' +
                '<font face="Arial" size="1" color="#FFF"><b>📁 RECOMMENDED FOR YOU</b></font></div>' +
                '<div style="background:#C0C0C0;padding:6px">' +
                '<div class="quick-add-container" style="margin-bottom:8px">' +
                '<div class="quick-add-btn" onclick="CartOS.toggleQuickAddRec(this)" style="padding:10px;border:2px dashed #800080;background:rgba(128,0,128,0.1);text-align:center;cursor:pointer;opacity:0.9" onmouseover="this.style.opacity=\'1\';this.style.borderColor=\'#AA00AA\';this.style.background=\'rgba(170,0,170,0.15)\'" onmouseout="this.style.opacity=\'0.9\';this.style.borderColor=\'#800080\';this.style.background=\'rgba(128,0,128,0.1)\'">' +
                '<font face="Arial" size="2" color="#800080"><b class="quick-add-text">📦 QUICK ADD CART</b></font></div>' +
                '<div class="quick-add-panel" style="display:none;margin-top:6px;background:#C0C0C0;border:2px outset #FFF">' +
                '<div style="background:#AA00AA;padding:4px 8px;display:flex;justify-content:space-between;align-items:center">' +
                '<font face="Arial" size="1" color="#0FC"><b>📦 Quick Add Items</b></font>' +
                '<span onclick="CartOS.toggleQuickAddRec(this)" style="color:#FFF;cursor:pointer;font-size:12px">✕</span></div>' +
                '<div style="padding:8px">' + this.generateQuickAddItems() + '</div>' +
                '<div style="padding:6px;background:#A0A0A0;border-top:2px groove #FFF;text-align:center">' +
                '<a href="/collections/all" style="text-decoration:none"><font face="Arial" size="1" color="#00F"><b>Browse All Products →</b></font></a></div>' +
                '</div></div>' +
                '<div style="display:flex;flex-wrap:wrap;gap:8px">' + smallCardsHtml + '</div>' +
                '</div></div>';
        },

        generateMembershipProgressBar: function(cartTotal) {
            // cartTotal arrives in USD base (callers pass tierTotal). Compares
            // use it directly against USD thresholds; money DISPLAYS go through
            // formatBase(), which converts USD→presentment and formats.
            var isLoggedIn = this.isLoggedIn;
            var thresholds = this.savingsThresholds;
            var maxThreshold = thresholds[thresholds.length - 1].amount;
            var progress = Math.min((cartTotal / maxThreshold) * 100, 100);

            var currentTierIndex = -1;
            for (var i = 0; i < thresholds.length; i++) {
                if (cartTotal >= thresholds[i].amount) currentTierIndex = i;
            }

            var savingsPercent = 0;
            if (currentTierIndex >= 3) savingsPercent = 20;
            else if (currentTierIndex >= 2) savingsPercent = 15;
            else if (currentTierIndex >= 1) savingsPercent = 10;

            var currentSavings = this.formatBase(cartTotal * (savingsPercent / 100));
            var nextTierPercent = 10;
            if (cartTotal >= 200) nextTierPercent = 20;
            else if (cartTotal >= 120) nextTierPercent = 15;
            var potentialSavings = this.formatBase(cartTotal * (nextTierPercent / 100));

            var tiersHtml = '';
            for (var i = 0; i < thresholds.length; i++) {
                var tier = thresholds[i];
                var bgColor = '#E8E8E8';
                var textColor = '#000';
                var isActive = cartTotal >= tier.amount;
                if (isActive) {
                    bgColor = isLoggedIn ? '#90EE90' : '#8B0000';
                    textColor = isLoggedIn ? '#000' : '#FFE088';
                }
                var glowClass = isActive ? 'tier-glow-box' : '';
                tiersHtml += '<td align="center" width="25%" style="padding:4px"><div class="' + glowClass + '" style="background:' + bgColor + ';border:2px outset #FFF;padding:8px;height:100%"><font face="Arial" size="1" color="' + textColor + '">' + tier.icon + '<br><b>' + tier.label + '</b><br>' + this.formatBase(tier.amount) + '</font></div></td>';
            }

            if (isLoggedIn) {
                var headerText = savingsPercent > 0 ? '💰 MEMBER SAVINGS YOU GET!' : '💰 UNLOCK MORE SAVINGS';
                var savingsText = savingsPercent > 0 ? 'YOU ARE SAVING' : 'ADD MORE TO SAVE';
                var displaySavings = savingsPercent > 0 ? currentSavings : potentialSavings;
                var subtext = savingsPercent > 0 ? 'with your ' + savingsPercent + '% member discount!' : 'Spend ' + this.formatBase(120 - cartTotal) + ' more for 10% OFF!';
                var progressText = savingsPercent > 0 ? 'Keep shopping for even more rewards!' : 'Unlock up to 20% OFF with your membership!';

                return '<div style="text-align:center">' +
                    '<table border="0" cellpadding="0" cellspacing="0" style="background:#C0C0C0;border:3px outset #FFF;margin:0 auto;width:50%;min-width:160px;max-width:280px">' +
                    '<tr><td style="background:#3a0a10;padding:8px;text-align:center">' +
                    '<font face="Arial" size="2" color="#FFE088"><b>' + headerText + '</b></font></td></tr>' +
                    '<tr><td style="background:#FFF;border:2px inset #808080;padding:12px;text-align:center">' +
                    '<font face="Arial" size="2" color="#006600">' + savingsText + '</font><br>' +
                    '<font face="Times New Roman" size="7" color="#006600"><b>' + displaySavings + '</b></font><br>' +
                    '<font face="Arial" size="1" color="#006600"><i>' + subtext + '</i></font></td></tr></table>' +
                    '<table width="100%" border="0" cellpadding="0" cellspacing="0" style="background:#E8E8E8;border:2px inset #A0A0A0;margin-top:8px">' +
                    '<tr><td style="padding:10px"><font face="Arial" size="1" color="#333">' + progressText + '</font>' +
                    '<table width="100%" border="2" cellpadding="0" cellspacing="0" style="margin:8px 0;border-color:#006600;background:#002200">' +
                    '<tr><td height="20"><div style="height:20px;width:' + progress + '%;background:#FFD700"></div></td></tr></table>' +
                    '<table width="100%" border="0" cellpadding="0" cellspacing="4"><tr>' + tiersHtml + '</tr></table>' +
                    '</td></tr></table></div>';
            } else {
                var guestTierPercent = 0;
                var guestTierLabel = '';
                if (cartTotal >= 350) { guestTierPercent = 20; guestTierLabel = '20% VIP'; }
                else if (cartTotal >= 200) { guestTierPercent = 15; guestTierLabel = '15% off'; }
                else if (cartTotal >= 120) { guestTierPercent = 10; guestTierLabel = '10% off'; }
                else if (cartTotal >= 99) { guestTierPercent = 0; guestTierLabel = 'FREE SHIPPING'; }
                else { guestTierPercent = 0; guestTierLabel = 'Add more to save!'; }

                var calculatedSavings = cartTotal * (guestTierPercent / 100);

                var randomIdx = Math.floor(Math.random() * this.recommendedProducts.length);
                var randomProd = this.recommendedProducts.length > 0 ? this.recommendedProducts[randomIdx] : null;
                var proposedSavings = randomProd ? this.formatMoney(randomProd.price * 0.15) : this.formatBase(9.75);

                if (cartTotal > 0 && guestTierPercent > 0) {
                    return '<div style="text-align:center"><table border="0" cellpadding="0" cellspacing="0" style="background:#C0C0C0;border:3px outset #FFF;margin:0 auto;width:50%;min-width:160px;max-width:280px">' +
                        '<tr><td style="background:#660000;padding:10px;text-align:center"><font face="Arial" size="3" color="#FFD700"><b>💰 MEMBER SAVINGS</b></font></td></tr>' +
                        '<tr><td style="background:#FFFFCC;border:2px inset #808080;padding:16px;text-align:center">' +
                        '<font face="Arial" size="1" color="#666">Cart Total: <b>' + this.formatBase(cartTotal) + '</b></font><br>' +
                        '<font face="Arial" size="2" color="#666">YOU COULD SAVE</font><br>' +
                        '<font face="Times New Roman" size="7" color="#CC0000"><b>' + this.formatBase(calculatedSavings) + '</b></font><br>' +
                        '<font face="Arial" size="2" color="#006600"><i>' + guestTierLabel + '!</i></font></td></tr></table></div>';
                } else if (cartTotal > 0 && cartTotal < 99) {
                    var shippingNeeded = this.formatBase(99 - cartTotal);
                    return '<div style="text-align:center"><table border="0" cellpadding="0" cellspacing="0" style="background:#C0C0C0;border:3px outset #FFF;margin:0 auto;width:50%;min-width:160px;max-width:280px">' +
                        '<tr><td style="background:#004400;padding:10px;text-align:center"><font face="Arial" size="3" color="#AAFFAA"><b>🚚 FREE SHIPPING</b></font></td></tr>' +
                        '<tr><td style="background:#E8FFE8;border:2px inset #808080;padding:16px;text-align:center">' +
                        '<font face="Arial" size="1" color="#666">Cart Total: <b>' + this.formatBase(cartTotal) + '</b></font><br>' +
                        '<font face="Arial" size="2" color="#006600">Add <b>' + shippingNeeded + '</b> more</font><br>' +
                        '<font face="Times New Roman" size="5" color="#006600"><b>for FREE SHIPPING!</b></font><br>' +
                        '<font face="Arial" size="1" color="#666"><i>Orders ' + this.formatBase(99) + '+ ship FREE</i></font></td></tr></table></div>';
                } else if (cartTotal > 0 && cartTotal >= 99 && cartTotal < 120) {
                    var discountNeeded = this.formatBase(120 - cartTotal);
                    return '<div style="text-align:center"><table border="0" cellpadding="0" cellspacing="0" style="background:#C0C0C0;border:3px outset #FFF;margin:0 auto;width:50%;min-width:160px;max-width:280px">' +
                        '<tr><td style="background:#660000;padding:10px;text-align:center"><font face="Arial" size="3" color="#FFD700"><b>💰 UNLOCK SAVINGS</b></font></td></tr>' +
                        '<tr><td style="background:#FFFFCC;border:2px inset #808080;padding:16px;text-align:center">' +
                        '<font face="Arial" size="1" color="#006600">✓ FREE SHIPPING UNLOCKED!</font><br>' +
                        '<font face="Arial" size="2" color="#666">Add <b>' + discountNeeded + '</b> more for</font><br>' +
                        '<font face="Times New Roman" size="5" color="#CC0000"><b>10% OFF!</b></font><br>' +
                        '<font face="Arial" size="1" color="#666"><i>Save up to 20% as a member</i></font></td></tr></table></div>';
                } else {
                    return '<div style="text-align:center"><table border="0" cellpadding="0" cellspacing="0" style="background:#C0C0C0;border:3px outset #FFF;margin:0 auto;width:50%;min-width:160px;max-width:280px">' +
                        '<tr><td style="background:#660000;padding:10px;text-align:center"><font face="Arial" size="3" color="#FFD700"><b>💰 MEMBER SAVINGS</b></font></td></tr>' +
                        '<tr><td style="background:#FFFFCC;border:2px inset #808080;padding:16px;text-align:center">' +
                        '<font face="Arial" size="2" color="#666">You could be saving...</font><br>' +
                        '<font face="Times New Roman" size="7" color="#CC0000"><b>' + proposedSavings + '</b></font><br>' +
                        '<font face="Arial" size="2" color="#006600"><i>with member rewards!</i></font></td></tr></table></div>';
                }
            }
        },

        generateMembershipCTA: function(cartTotal) {
            var isLoggedIn = this.isLoggedIn;
            var thresholds = this.savingsThresholds;
            var accountUrl = DATA.accountUrl || '/account';
            var randomIndex = Math.floor(Math.random() * this.recommendedProducts.length);
            var randomProduct = this.recommendedProducts.length > 0 ? this.recommendedProducts[randomIndex] : null;
            var randomProductSavings = randomProduct ? this.formatMoney(randomProduct.price * 0.15) : this.formatBase(7.50);

            if (isLoggedIn) {
                var currentTierIndex = -1;
                for (var i = 0; i < thresholds.length; i++) {
                    if (cartTotal >= thresholds[i].amount) currentTierIndex = i;
                }
                var savingsPercent = 0;
                if (currentTierIndex >= 3) savingsPercent = 20;
                else if (currentTierIndex >= 2) savingsPercent = 15;
                else if (currentTierIndex >= 1) savingsPercent = 10;

                var currentSavings = this.formatBase(cartTotal * (savingsPercent / 100));
                var potentialAtNextTier = this.formatBase(cartTotal * 0.10);

                var ctaHeader = '', ctaAmount = '', ctaSubtext = '', ctaTierProgress = '';

                if (cartTotal === 0) {
                    ctaHeader = '💰 You Could Be Saving';
                    ctaAmount = randomProductSavings;
                    ctaSubtext = 'with member rewards!';
                } else if (savingsPercent > 0) {
                    ctaHeader = '💰 YOU ARE SAVING';
                    ctaAmount = currentSavings;
                    ctaSubtext = 'with your member rewards!';
                    if (cartTotal >= 350) {
                        ctaTierProgress = '🎉 MAXIMUM SAVINGS!';
                    } else {
                        var nextTierThreshold = cartTotal >= 200 ? 350 : (cartTotal >= 120 ? 200 : 120);
                        var nextTierPct = cartTotal >= 200 ? 20 : (cartTotal >= 120 ? 15 : 10);
                        ctaTierProgress = 'Add ' + this.formatBase(nextTierThreshold - cartTotal) + ' for ' + nextTierPct + '% OFF!';
                    }
                } else {
                    ctaHeader = '💰 UNLOCK 10% OFF';
                    ctaAmount = potentialAtNextTier;
                    ctaSubtext = 'Add ' + this.formatBase(120 - cartTotal) + ' more!';
                    ctaTierProgress = 'Could save ' + potentialAtNextTier + ' with 10% discount';
                }

                return '<table width="100%" border="3" cellpadding="6" cellspacing="0" style="border-color:#006600;background:#A0A0A0">' +
                    '<tr><td align="center"><font face="Arial" size="1" color="#006600"><b>✓ RETARD GLOBAL MEMBER</b></font></td></tr></table>' +
                    '<div style="text-align:center;margin-top:8px">' +
                    '<table border="3" cellpadding="8" cellspacing="0" style="border-color:#006600;background:#FFFFCC;width:50%;min-width:140px;max-width:220px;margin:0 auto">' +
                    '<tr><td align="center"><font face="Arial" size="1" color="#666">' + ctaHeader + '</font><br>' +
                    '<font face="Times New Roman" size="6" color="#006600"><b>' + ctaAmount + '</b></font><br>' +
                    '<font face="Arial" size="1" color="#006600"><i>' + ctaSubtext + '</i></font>' +
                    (ctaTierProgress ? '<br><font face="Arial" size="1" color="#006600"><b>' + ctaTierProgress + '</b></font>' : '') +
                    '</td></tr></table></div>' +
                    '<table width="100%" border="3" cellpadding="4" cellspacing="0" style="margin-top:8px;border-color:#006600;background:#FFF">' +
                    '<tr><td bgcolor=#800080 align="center"><font face="Arial" size="1" color="#FFF"><b>⭐ YOUR MEMBER BENEFITS</b></font></td></tr>' +
                    '<tr><td><table width="100%" border="0" cellpadding="4" cellspacing="2"><tr>' +
                    '<td align="center" width="25%" style="background:' + (cartTotal >= 99 ? '#E8FFE8' : '#F0F0F0') + ';border:1px solid ' + (cartTotal >= 99 ? '#00AA00' : '#CCC') + '"><font face="Arial" size="1">🚚<br><b>' + (cartTotal >= 99 ? '✓ ' : '') + 'FREE SHIP</b><br><small>' + this.formatBase(99) + '+</small></font></td>' +
                    '<td align="center" width="25%" style="background:#E8FFE8;border:1px solid #00AA00"><font face="Arial" size="1">⭐<br><b>✓ VIP ACCESS</b><br><small>Early Drops</small></font></td>' +
                    '<td align="center" width="25%" style="background:#E8FFE8;border:1px solid #00AA00"><font face="Arial" size="1">🏆<br><b>✓ VIP STATUS</b><br><small>Exclusive</small></font></td>' +
                    '<td align="center" width="25%" style="background:#FFFFD0;border:1px solid #CCAA00"><font face="Arial" size="1">📦<br><b>✓ WHOLESALE</b><br><small>1dz ' + this.formatBase(60) + '/ea<br>3dz ' + this.formatBase(50) + '/ea<br>5dz ' + this.formatBase(40) + '/ea</small></font></td>' +
                    '</tr></table></td></tr></table>' +
                    '<table width="100%" border="3" cellpadding="4" cellspacing="0" style="margin-top:8px;border-color:#006600;background:#001100">' +
                    '<tr><td align="center"><font face="Courier New" size="1" color="#0F0">◆ MEMBERSHIP STATUS ◆</font><br>' +
                    '<font face="Courier New" size="2" color=#FFD700><b>★★★★★ RETARD GLOBAL MEMBER ★★★★★</b></font></td></tr></table>';
            } else {
                var guestCtaHeader = '', guestCtaAmount = '', guestCtaSubtext = '', guestTierProgress = '';
                var guestSavingsPercent = 0, guestSavingsLabel = '';
                if (cartTotal >= 350) { guestSavingsPercent = 20; guestSavingsLabel = '20% OFF'; }
                else if (cartTotal >= 200) { guestSavingsPercent = 15; guestSavingsLabel = '15% OFF'; }
                else if (cartTotal >= 120) { guestSavingsPercent = 10; guestSavingsLabel = '10% OFF'; }

                if (cartTotal === 0) {
                    guestCtaHeader = '💰 You Could Be Saving';
                    guestCtaAmount = randomProductSavings;
                    guestCtaSubtext = 'with member rewards!';
                } else if (guestSavingsPercent > 0) {
                    guestCtaHeader = '💰 YOU COULD BE SAVING';
                    var guestCalcSavings = cartTotal * (guestSavingsPercent / 100);
                    guestCtaAmount = this.formatBase(guestCalcSavings >= 1 ? guestCalcSavings : 21.00);
                    guestCtaSubtext = 'with ' + guestSavingsLabel + ' member discount!';
                    if (cartTotal < 350) {
                        var nextGuestTier = cartTotal >= 200 ? 350 : (cartTotal >= 120 ? 200 : 120);
                        var nextGuestPercent = cartTotal >= 200 ? '20%' : (cartTotal >= 120 ? '15%' : '10%');
                        guestTierProgress = 'Add ' + this.formatBase(nextGuestTier - cartTotal) + ' more for ' + nextGuestPercent + ' OFF!';
                    } else {
                        guestTierProgress = '🎉 MAXIMUM SAVINGS TIER!';
                    }
                } else {
                    guestCtaHeader = '💰 YOU COULD BE SAVING';
                    guestCtaAmount = this.formatBase(120 * 0.10);
                    guestCtaSubtext = 'Sign up FREE for member rewards!';
                    guestTierProgress = 'Add ' + this.formatBase(120 - cartTotal) + ' more for 10% OFF!';
                }

                return '<table width="100%" border="3" cellpadding="8" cellspacing="0" style="border-color:#CCC;background:#F00">' +
                    '<tr><td align="center"><font face="Arial" size="1" color="#FF0"><b>🔥 LIMITED TIME OFFER 🔥</b></font><br>' +
                    '<font face="Arial" size="4" color="#FFF"><b>🎁 UP TO 20% OFF</b></font><br>' +
                    '<font face="Arial" size="2" color="#FFF">Join FREE & unlock your exclusive discount!</font></td></tr></table>' +
                    '<div style="text-align:center;margin-top:8px">' +
                    '<table border="3" cellpadding="8" cellspacing="0" style="border-color:#CCC;background:#FFFFCC;width:50%;min-width:140px;max-width:220px;margin:0 auto">' +
                    '<tr><td align="center"><font face="Arial" size="1" color="#666">' + guestCtaHeader + '</font><br>' +
                    '<font face="Times New Roman" size="6" color="#F00"><b>' + guestCtaAmount + '</b></font><br>' +
                    '<font face="Arial" size="1" color="#006600"><i>' + guestCtaSubtext + '</i></font>' +
                    (guestTierProgress ? '<br><font face="Arial" size="1" color="#006600"><b>' + guestTierProgress + '</b></font>' : '') +
                    '</td></tr></table></div>' +
                    '<table width="100%" border="3" cellpadding="4" cellspacing="0" style="margin-top:8px;border-color:#CCC;background:#FFF">' +
                    '<tr><td bgcolor=#800080 align="center"><font face="Arial" size="1" color="#FFF"><b>⭐ MEMBER BENEFITS</b></font></td></tr>' +
                    '<tr><td><table width="100%" border="0" cellpadding="4" cellspacing="2"><tr>' +
                    '<td align="center" width="20%" style="background:#F8F8F8;border:1px solid #CCC"><font face="Arial" size="1">🎁<br><b>15% OFF</b><br><small>1st Order</small></font></td>' +
                    '<td align="center" width="20%" style="background:#F8F8F8;border:1px solid #CCC"><font face="Arial" size="1">🚚<br><b>FREE SHIP</b><br><small>' + this.formatBase(99) + '+</small></font></td>' +
                    '<td align="center" width="20%" style="background:#F8F8F8;border:1px solid #CCC"><font face="Arial" size="1">🏆<br><b>VIP STATUS</b><br><small>Exclusive</small></font></td>' +
                    '<td align="center" width="20%" style="background:#F8F8F8;border:1px solid #CCC"><font face="Arial" size="1">⭐<br><b>VIP</b><br><small>Early Drops</small></font></td>' +
                    '<td align="center" width="20%" style="background:#FFFFD0;border:1px solid #CCAA00"><font face="Arial" size="1">📦<br><b>WHOLESALE</b><br><small>1dz ' + this.formatBase(60) + '/ea<br>3dz ' + this.formatBase(50) + '/ea<br>5dz ' + this.formatBase(40) + '/ea</small></font></td>' +
                    '</tr></table></td></tr></table>' +
                    '<a href="' + accountUrl + '" style="display:block;text-decoration:none;margin-top:8px">' +
                    '<table width="100%" border="3" cellpadding="12" cellspacing="0" style="border-color:#FFCC00;background:#FF8C00;cursor:pointer">' +
                    '<tr><td align="center"><font face="Arial" size="3" color="#000"><b><span class="flashing-stars">✦</span> JOIN RETARD GLOBAL <span class="flashing-stars">✦</span></b></font></td></tr></table></a>' +
                    '<table width="100%" border="0" cellpadding="4" cellspacing="0" style="margin-top:4px">' +
                    '<tr><td align="center"><font face="Arial" size="1" color="#666">⚡ Takes 30 seconds • 2,500+ members worldwide</font></td></tr></table>';
            }
        },

        render: function(cart) {
            var html = this.generateHTML(cart);
            if (this.contentEl) this.contentEl.innerHTML = html;
            var pageCart = document.getElementById('retro-page-cart-content');
            if (pageCart) pageCart.innerHTML = html;
        }
    };

    // Register with PROGRAMS
    window.PROGRAMS.register('Cart', Cart);

    // BACKWARD COMPATIBILITY: window.CartOS = PROGRAMS.Cart
    window.CartOS = Cart;

})();
